import { render, staticRenderFns } from "./DataCompletion.vue?vue&type=template&id=a7e9db48"
import script from "./DataCompletion.vue?vue&type=script&lang=js"
export * from "./DataCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports